(() => {
  // app/scripts/yard-details.js
  var YardDetails = class extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }
    bindEvents() {
      if (theme.device.hasTouch) {
        this.addEventListener("click", (e) => {
          this.classList.toggle("is-open");
        });
        this.addEventListener("blur", (e) => {
          this.classList.remove("is-open");
        });
      } else {
        this.addEventListener("mouseenter", (e) => {
          this.classList.add("is-open");
        });
        this.addEventListener("mouseleave", (e) => {
          this.classList.remove("is-open");
        });
      }
    }
  };
  customElements.define("yard-details", YardDetails);
})();
